import RecommendationApi from 'client/api/v2/RecommendationApi';
import Vue from 'vue';

export const initialState = () => ({
  recommendedPackage: {},
  recommendedAddOns: [],
});

export default {
  namespaced: true,

  state: initialState(),

  actions: {
    async fetchRecommendations({ commit }) {
      const resp = await RecommendationApi.fetch();

      commit('SET_RECOMMENDATIONS', resp.data);
    },
  },

  getters: {
    hasRecommendations: (state, getters, rootState) => rootState.SettingsModule.isCustomer
      && ('displayName' in state.recommendedPackage
      || state.recommendedAddOns.length > 0),
  },

  mutations: {
    SET_RECOMMENDATIONS(state, recommendationData) {
      Vue.set(state, 'recommendedPackage', recommendationData.recommendedPackage);
      Vue.set(state, 'recommendedAddOns', recommendationData.recommendedAddOns);
    },
  },
};
